export default __webpack_public_path__ + "static/media/Gallery.f8f9b4f0.svg";